import { render, staticRenderFns } from "./NotAccessPage.vue?vue&type=template&id=77a81b2c"
import script from "./NotAccessPage.vue?vue&type=script&lang=js"
export * from "./NotAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports